import type { DeepPartial } from '@luna/utils-ts';

import type { Pip } from '../../types/Pip';

export const pipROFeatureConfig: DeepPartial<Pip> = {
    shouldShowBackNavigationOnOrderSummary: true,
    shouldShowFullCatalogueLink: true,
    tilePriceHistoryExchangeCode: 'OTC',
};
